import { render, staticRenderFns } from "./Gravatar.vue?vue&type=template&id=278f093e&scoped=true"
import script from "./Gravatar.vue?vue&type=script&lang=js"
export * from "./Gravatar.vue?vue&type=script&lang=js"
import style0 from "./Gravatar.vue?vue&type=style&index=0&id=278f093e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f093e",
  null
  
)

export default component.exports